import { type TemplateDehydratedState, TemplateStore } from '@/tools/models/template.store';

export type ScalingTemplateDehydratedState = TemplateDehydratedState;

/**
 * Store for templates within scaling tables
 * Templates can be created and edited in multiple places (e.g. tool pane, scaling tables)
 * so we need a dedicated store for the model tool to avoid conflicts with other places.
 */
export class ScalingTemplateStore extends TemplateStore {
  static readonly storeName = 'sqScalingTemplateStore';

  override dehydrate(): ScalingTemplateDehydratedState {
    return super.dehydrate();
  }

  override rehydrate(dehydratedState: Partial<ScalingTemplateDehydratedState>): void {
    super.rehydrate(dehydratedState);
  }

  protected override readonly handlers = {
    ...this.baseHandlers,
    SCALING_MODEL_RESET_MODEL: this.resetTemplate,
    SCALING_MODEL_SET_MODEL: this.setTemplate,
    SCALING_MODEL_SET_FEATURE_TO_EDIT_ID: this.setFeatureToEditId,
    SCALING_MODEL_SET_INSTANCE_TO_EDIT_ID: this.setInstanceToEditId,
    SCALING_MODEL_SET_MODEL_OUTPUT: this.setTemplateOutput,
    SCALING_MODEL_SET_VERSION_STATE: this.setVersionState,
    SCALING_MODEL_SET_INSTANCE_COUNT: this.setInstanceCount,
  };
}
